import { FormInputMeta } from '@Modules/core/types/FormMetaType';
import commonFormMeta from '@Shared/components/form/commonFormMeta';
import { capitalize } from '@Shared/utils/helpers';
import { getValidationSchema } from '@Shared/utils/validationSchema';
import * as yup from "yup";


export interface IUpdateFormMeta {
    interfaceType: FormInputMeta;
    interfaceCode: FormInputMeta;
    identifier: FormInputMeta;
    name: FormInputMeta;
    status: FormInputMeta;
    lastUpTime: FormInputMeta;
    lastDownTime: FormInputMeta;
    processIdentifier: FormInputMeta;
    numberOfThreads: FormInputMeta;
    startScript: FormInputMeta;
    stopScript: FormInputMeta;
    numberOfProcesses: FormInputMeta;
    //
    primaryAddress: FormInputMeta;
    secondaryAddress: FormInputMeta;
    primaryPort: FormInputMeta;
    secondaryPort: FormInputMeta;
    destinationAccessPoint: FormInputMeta;
    sourceAccessPoint: FormInputMeta;
    debitNetworkIdentifier: FormInputMeta;
    timeOutAcquirer: FormInputMeta;
    timeOutIssuer: FormInputMeta;
    reconnectFlag: FormInputMeta;
    numberOfReconnectionAttempts: FormInputMeta;
    timeBetweenTwoAttempts: FormInputMeta;
    //
    fchTrace: FormInputMeta;
    level: FormInputMeta;
    incomingMessage: FormInputMeta;
    outgoingMessage: FormInputMeta;
    refreshMethod: FormInputMeta;
    maxTraceSize: FormInputMeta;
    //
    schema: any;
  }

const UpdateFormMeta = {} as IUpdateFormMeta;

UpdateFormMeta.interfaceType = {
  name: "interfaceType",
  label: "Type interface",
  type: "select",
  options:  [],
  validation: yup.string().required("Ce champ est requis"),
};
UpdateFormMeta.interfaceCode = {
  name: 'interfaceCode',
  type: 'text',
  label: 'Code interface',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};
UpdateFormMeta.identifier = {
  name: 'identifier',
  type: 'text',
  label: 'ID',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};
UpdateFormMeta.name = {
  name: 'name',
  type: 'text',
  label: 'Nom',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};
UpdateFormMeta.status = {
  name: 'status',
  type: 'text',
  label: 'Statut',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};
UpdateFormMeta.lastUpTime = {
  name: 'lastUpTime',
  type: 'datetime',
  label: 'Dernier Up Time',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};
UpdateFormMeta.lastDownTime = {
  name: 'lastDownTime',
  type: 'datetime',
  label: 'Dernier Down Time',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};
UpdateFormMeta.processIdentifier = {
  name: 'processIdentifier',
  type: 'text',
  label: 'Id Process',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};
UpdateFormMeta.numberOfThreads = {
  name: 'numberOfThreads',
  type: 'number',
  label: 'Nombre de threads',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};
UpdateFormMeta.startScript = {
  name: 'startScript',
  type: 'text',
  label: 'Script de demarrage',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};
UpdateFormMeta.stopScript = {
  name: 'stopScript',
  type: 'text',
  label: 'Script d\'arrêt',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};
UpdateFormMeta.numberOfProcesses = {
  name: 'numberOfProcesses',
  type: 'number',
  label: 'Nombre de process',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};

//------------------------------------------------

UpdateFormMeta.primaryAddress = {
  name: 'primaryAddress',
  type: 'text',
  label: 'Adresse primaire',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};
UpdateFormMeta.secondaryAddress = {
  name: 'secondaryAddress',
  type: 'text',
  label: 'Adresse secondaire',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};
UpdateFormMeta.primaryPort = {
  name: 'primaryPort',
  type: 'text',
  label: 'Port primaire',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};
UpdateFormMeta.secondaryPort = {
  name: 'secondaryPort',
  type: 'text',
  label: 'Port secondaire',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};
UpdateFormMeta.destinationAccessPoint = {
  name: 'destinationAccessPoint',
  type: 'text',
  label: 'Point d\'accès destination',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};
UpdateFormMeta.sourceAccessPoint = {
  name: 'sourceAccessPoint',
  type: 'text',
  label: 'Point d\'accès source',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};
UpdateFormMeta.debitNetworkIdentifier = {
  name: 'debitNetworkIdentifier',
  type: 'text',
  label: 'Identifiant de réseau de débit',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};
UpdateFormMeta.timeOutAcquirer = {
  name: 'timeOutAcquirer',
  type: 'text',
  label: 'Time out acquereur',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};
UpdateFormMeta.timeOutIssuer = {
  name: 'timeOutIssuer',
  type: 'text',
  label: 'Time out emetteur',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};
UpdateFormMeta.reconnectFlag = {
  name: 'reconnectFlag',
  type: 'checkbox',
  label: 'Flag de reconnection',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};
UpdateFormMeta.numberOfReconnectionAttempts = {
  name: 'numberOfReconnectionAttempts',
  type: 'text',
  label: 'Nombre d\'essais de reconnection',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};
UpdateFormMeta.timeBetweenTwoAttempts = {
  name: 'timeBetweenTwoAttempts',
  type: 'text',
  label: 'Delai entre 02 essais',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};


//
UpdateFormMeta.fchTrace = {
  name: 'fchTrace',
  type: 'number',
  label: 'Fch Trace',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};
UpdateFormMeta.level = {
  name: 'level',
  type: 'select',
  label: 'Niveau',
  options: [],
  validation: yup.string().required("Ce champ est requis"),
};
UpdateFormMeta.incomingMessage = {
  name: 'incomingMessage',
  type: 'number',
  label: 'Message entrant',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};
UpdateFormMeta.outgoingMessage = {
  name: 'outgoingMessage',
  type: 'number',
  label: 'Message sortant',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};
UpdateFormMeta.refreshMethod = {
  name: "refreshMethod",
  label: "Methode de rafraichissement",
  type: "select",
  options:  [
    {
      label:'Taille',
      value: 't',
    },
    {
      label:'Quotidiennement',
      value: 'q',
    },
  ],
  validation: yup.string().required("Ce champ est requis"),
};
UpdateFormMeta.maxTraceSize = {
  name: "maxTraceSize",
  label: "Taille Max Trace",
  type: "text",
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};





UpdateFormMeta.schema = yup.object().shape(getValidationSchema(UpdateFormMeta));

export default UpdateFormMeta;